



















import { Component, Mixins, Prop } from "vue-property-decorator";
import {
  IImageSpecifiableButtonState,
} from "../panes";

@Component
export default class ExternalMenuButton extends Mixins() {
  @Prop({ default: "bottom-start" })
  tooltipPlacement: string;
  
  @Prop()
  button: IImageSpecifiableButtonState;

  splitByReturnCode(value: string): string[] {
    const filledValue = value ? value : "";
    return filledValue.split("\n");
  }

  get buttonStyle(): any {
    if (!!this.button.definition.iconClass) { return null; }

    const imageSource = this.button.isEnable
      ? this.button.definition.iconImageSource
      : this.button.definition.disableIconImageSource;
    if (!imageSource) { return null; }

    return {
      backgroundImage: "url(\"" + imageSource + "\")",
      backgroundSize: "30px 30px",
    };
  }
}
